import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    Text,
    VStack,
    HStack,
    useToast
} from '@chakra-ui/react';
import useProductStore from '../../zustand/useProductStore';

const options = [
    "Front of property",
    "Garden",
    "Back of house",
    "View from property",
    "Garage",
    "No – interior only"
];

function CustomExternalPhotosModal({ isOpen, onClose, handleContinue }) {
    const { CustomPhotoOptions, setCustomPhotoOptions, propertyDetails, setPropertyDetails } = useProductStore();
    const toast = useToast();

    const handleOptionClick = (option) => {
        let updated = [...CustomPhotoOptions];

        if (option === "No – interior only") {
            updated = updated.includes(option) ? [] : [];
            if (!CustomPhotoOptions.includes(option)) {
                updated = [option];
            }
        } else {
            updated = updated.filter(o => o !== "No – interior only");
            if (updated.includes(option)) {
                updated = updated.filter(o => o !== option);
            } else {
                updated.push(option);
            }
        }

        setCustomPhotoOptions(updated);
        setPropertyDetails({
            ...propertyDetails,
            CustomPhotoOptions: updated
        });
    };

    const handleContinueBtn = () => {
        if (CustomPhotoOptions.length === 0) {
            toast({
                title: "Please select at least one option",
                variant: "left-accent",
                status: "error",
                duration: 2000,
                position: "bottom-right",
            });
        }
        else {
            handleContinue();
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent bg="white" color="black.100" p={5}>
                <ModalBody>
                    <VStack spacing={4} textAlign="center" mt={6}>
                        <Text fontSize="lg" fontWeight="bold">
                            External Photos (optional)
                        </Text>
                        <VStack spacing={2} align="start" width="100%">
                            {options.map(option => (
                                <HStack
                                    key={option}
                                    onClick={() => handleOptionClick(option)}
                                    cursor="pointer"
                                    border={CustomPhotoOptions.includes(option) ? "2px solid #BEEF8E" : "2px solid transparent"}
                                    px={3}
                                    py={2}
                                    borderRadius="full"
                                    width="100%"
                                    justifyContent="center"
                                >
                                    <Text>{option}</Text>
                                </HStack>
                            ))}
                        </VStack>
                        <Text fontSize="sm" marginTop="5" color="gray.600">
                            If you choose to include external photos: It will reduce the number of internal images available to you. External images count toward the 10-image limit in the Budget package. If you need more images, consider upgrading to the Standard or Premium package.
                        </Text>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button
                        colorScheme="blue"
                        mt={2}
                        mx="auto"
                        bgColor="green.1000"
                        onClick={handleContinueBtn}
                        _hover={{ bg: 'green.1000', opacity: '0.7' }}
                        px={8}
                    >
                        Continue
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default CustomExternalPhotosModal;
